export default "__VITE_ASSET__xTcxvYFr__"